import * as actions from './relatorios.action';
import inicialState from './relatorios.state';

const arquivamentoRelatoriosReducer = (state = inicialState, action) => {
  switch (action.type) {
      case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_INICIO:
      return {
        ...state,
        dataInicio: action.payload.dataInicio,
      };
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_DATA_FIM:
      return {
        ...state,
        dataFim: action.payload.dataFim,
      };
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPOPERIODO:
        return {
          ...state,
          tipoPeriodo: action.payload.tipoPeriodo,
        };
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_FILTRO_VALUE:
      return {
        ...state,
        filtroValue: action.payload.filtroValue,
      };
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_LISTA:
      return {
        ...state,
        lista: action.payload.lista,
      };
   
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_TIPO:
      return {
        ...state,
        tipo: action.payload.tipo,
      };
   
    case actions.ARQUIVAMENTO_RELATORIOS_ATUALIZAR_IMPRIMIR:
      return {
        ...state,
        imprimir: action.payload.imprimir,
      };
   
    default:
      return state;
  }
};

export default arquivamentoRelatoriosReducer;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Relatorios/store/relatorios.reducer.js